// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4ab07e00] .bj-page .el-form-item__label {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
